import { createFileRoute } from '@tanstack/react-router';
import { PageHead } from '../../components/ui/common';

// Placeholder — lane lead replaces this file (see CLAUDE.md "Route map").
export const Route = createFileRoute('/_app/module/$moduleId')({
  component: () => <PageHead title="מודול" lead="בבנייה" />,
});
